import React from "react";
import { Accordion, Button, Card, Form } from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import "./CreateSoftwareCatalogDialog.css";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class CreateSoftwareCatalogDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        initValid: false,
        rule: value => ValidationHelper.isNonEmptyStringOfLength(value, 3, 50)
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: false,
        rule: ValidationHelper.isNonEmptyExtendedDescription
      },
      provider: {
        defaultValue: undefined,
        initValid: false,
        rule: value => ValidationHelper.isIntInRange(value, 0, 1)
      }
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition)
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        size="lg"
        dialogApiError={this.props.dialogApiError}
        title={t("SoftwareCatalogs.CreateModal.Title")}
        leftButtonCallback={this.onHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        rightButtonCallback={this.onSubmit}
        rightButtonText={t("SoftwareCatalogs.CreateModal.Form.Submit")}
        rightButtonVariant="green"
        body={(<Form onSubmit={this.onSubmit}>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="0"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.name.isValid &&
                      this.state.validation.provider.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>
                    {t("SoftwareCatalogs.CreateModal.Form.ToggleBasic")}
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form.Group controlId="formScriptName">
                    <Form.Label>
                      {t("SoftwareCatalogs.CreateModal.Form.CatalogName")}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder={t(
                        "SoftwareCatalogs.CreateModal.Form.CatalogNamePlaceholder"
                      )}
                      value={this.state.validation.name.value}
                      isInvalid={!this.state.validation.name.isValid}
                      onChange={this.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SoftwareCatalogs.CreateModal.Form.ValidationError.Name"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsPublished">
                    <Form.Label>
                      {t("SoftwareCatalogs.CreateModal.Form.Provider")}
                    </Form.Label>
                    <BaseSelect
                      options={[
                        { label: "CAMPLA", value: 0 },
                        { label: "Chocolatey", value: 1 }
                      ]}
                      menuPosition="fixed"
                      placeholder={t(
                        "SoftwareCatalogs.CreateModal.Form.ProviderPlaceholder"
                      )}
                      onChange={value => {
                        this.handleChange({
                          target: {
                            name: "provider",
                            value: value.value
                          }
                        });
                      }}
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.provider.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SoftwareCatalogs.CreateModal.Form.ValidationError.Provider"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="1"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.description.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>
                    {t("SoftwareCatalogs.CreateModal.Form.Description")}
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <MarkDownEditor
                    defaultValue={ValidationHelper.getDefaultValueExtendedDescription()}
                    onChange={value =>
                      this.handleChange({
                        target: {
                          name: "description",
                          value: value
                        }
                      })
                    }
                  />
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Form>)}
      />
    );
  }
}

export default withTranslation()(CreateSoftwareCatalogDialog);
